import { Link } from "react-router-dom";
import { TCourse } from "../../types";

export interface ICourseLayerProps {
  courseType: string;
  header: string;
  courses: TCourse[];
}

export function CourseLayer(props: ICourseLayerProps) {
  let index = 1;
  return (
    <div
      id={props.header}
      style={{
        display: "flex",
        flexDirection: "column",
        border: "1px solid #c4c4c4",
        borderRadius: "20px",
        paddingTop: "25px",
        paddingLeft: "45px",
      }}
    >
      <h2 className="CoursesCardsCourseTitle">{props.header}</h2>

      <div className="CourseCardsCourses">
        {props.courses.map((data) => (
          <div key={data.id}>
            <p style={{ fontWeight: "bold", fontSize: "36px", margin: "0" }}>
              {" "}
              {index > 9 ? index++ : "0" + index++}
            </p>

            <Link
              style={{
                marginTop: "1rem",
                display: "inline-block",
                fontWeight: "normal",
                fontSize: "18px",
                lineHeight: "22px",
              }}
              to={`/${props.courseType.toLowerCase()}/${data.id}`}
            >
              {data.siteName}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
